<template>
  <modal :show="isModalVisible" @close="isModalVisible = false" class="prompt-modal text-left" :persist="true">
    <div class="modal-header ">
      <h3 class="m-0">
        A practice with this email already exists
      </h3>
    </div>
    <div class="modal-body d-flex">
      <div>
        <p class="lead" style="max-width: 450px">
          It seems like this email is linked to the following practice:
        </p>
        <div class="alert alert-muted" style="font-size: 1.35em">
          <b>{{ practice.name }}</b>
          <address v-html="$helpers.address(practice, '<br />')"></address>
          <p class="m-0" v-if="practice.phone">
            Tel: {{ practice.phone | phone }}
          </p>
          <p class="m-0" v-if="practice.fax">
            Fax: {{ practice.fax | phone }}
          </p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-lg btn-xl btn-primary btn-block" @click="$emit('selected', practice)" :disabled="isSubmitting">
        <font-awesome-icon icon="spinner-third" v-if="isSubmitting" spin />
        <span v-else>Yes, use this practice!</span>
      </button>
      <a href="javascript:;" class="btn btn-link btn-block font-weight-bolder mr-3" @click="close">No, let me change the email</a>

    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import { mapState } from 'vuex'
export default {
  props: ['practice'],
  components: { Modal },
  data() {
    return {
      isModalVisible: true,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState('auth', ['user', 'token', 'error']),
  },
  mounted() {},
  methods: {
    close() {
      this.isModalVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style scoped lang="scss">
.prompt-modal .modal-container {
  width: 100%;
}
@media (min-width: 576px) {
  .prompt-modal .modal-container {
    width: 500px;
  }
}
</style>
